export const AppPermissions = {
  // Main permissions
  PortalAccess: ['SBSV.PortalAccess@SBSV'],
};
